import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { AddPhotoSheetComponent } from "../helper/components/add-photo-sheet/add-photo-sheet.component";
import { AddMediaSheetComponent } from "../helper/components/add-media-sheet/add-media-sheet.component";
import { GalleryModalComponent } from "../helper/components/gallery-modal/gallery-modal.component";
import { GalleryComponent } from "../helper/components/gallery/gallery.component";
import { ImagePreviewComponent } from "../helper/components/image-preview/image-preview.component";
import { MediaGalleryModalComponent } from "../helper/components/media-gallery-modal/media-gallery-modal.component";
import { DrawingComponent } from "../helper/components/drawing/drawing.component";
import { ImageDrawingModule } from "ngx-image-drawing";

@NgModule({
    imports: [IonicModule, CommonModule, TranslateModule,ImageDrawingModule],
    declarations: [GalleryComponent, GalleryModalComponent, ImagePreviewComponent, AddPhotoSheetComponent,AddMediaSheetComponent,MediaGalleryModalComponent,DrawingComponent],
    exports: [GalleryComponent, GalleryModalComponent, ImagePreviewComponent, AddPhotoSheetComponent,AddMediaSheetComponent,MediaGalleryModalComponent,DrawingComponent]
})
export class MediaModule { }